import { topologyList } from "./../../constants/kpiSummaryDashboardEnhancement/kpiSummaryMainConstants";

const iState = {
    topologyOptions: [],
};

export default (state = iState, action) => {
    console.log("action data:", action.topologyOpt);
    switch (action.type) {
        case topologyList:
            return {
                topologyOptions: action.topologyOpt,
            };
        default:
            return state;
    }
};
